var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 px-4 fsize12 bg-white rounded-full border-green text-success"})
}
var staticRenderFns = []

export { render, staticRenderFns }